import Publisher from "./Publisher";

export default class PublisherList {
  constructor(name, initialValue = [], namespace, admsNameSpace, notationNameSpace, schemaAgencyNameSpace, isEditor = false) {
    this.namespace = namespace;
    this.name = name;
    this.admsNameSpace = admsNameSpace;
    this.notationNameSpace = notationNameSpace;
    this.schemaAgencyNameSpace = schemaAgencyNameSpace;
    this.publisherList = [];
    this.isEditor = isEditor;
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.addValueObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getObjList() {
    return this.publisherList;
  }

  setObjList(fpublisherList) {
    this.publisherList = fpublisherList;
  }

  removeValueObj(item, index) {
    if (index < 0 || index >= this.publisherList.length) {
      return;
    }
    this.publisherList.splice(index, 1);
  }

  addValueObj(obj) {
    const publisher = new Publisher(this.name, obj, this.namespace, this.admsNameSpace, this.notationNameSpace, this.schemaAgencyNameSpace);
    this.publisherList.push(publisher);
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON[this.namespace];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.addValueObj(value);
      }
    } else {
      if (!obj && this.isEditor) { // if it is undefined - either it is empty coming from editor ,
        // either it is empty coming from landing page. both need different handling
        this.addValueObj(obj);
      }
    }
  }

  getExpandedFormatValue() {
    const expandedList = [];
    for (let index = 0; index < this.publisherList.length; index++) {
      const pubItem = this.publisherList[index];
      expandedList.push(pubItem.getExpandedFormatValue());
    }
    return expandedList;
  }

  isEmpty() {
    let condition = true;
    for (let index = 0; index < this.publisherList.length; index++) {
      const pubItem = this.publisherList[index];
      condition = condition && pubItem.isEmpty();
    }
    return condition;
  }
}
